
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import BaseRabotaAgroUniversityCard from '@rshb/rshb-vue-kit/src/projects/rabotaAgro/cards/BaseRabotaAgroUniversityCard.vue'
import { UniversityCardModel } from '~/model'

@Component({
  components: {
    BaseRabotaAgroUniversityCard
  }
})
export default class extends Vue {
  @Prop({
    default: () => ({
      id: '',
      name: '',
      image: '',
      programs: '',
      price: ''
    })
  })
  readonly universityCard!: UniversityCardModel

  clickCard(card: any) {
    this.$emit('on-click-card', card)
  }
}
